<h1 mat-dialog-title>Future Change Sets</h1>
<mat-progress-spinner
    *ngIf="spinner"
    [color]="color"
    [diameter]="diameter"
    [mode]="mode"
    style="margin: 40px auto;"
>
</mat-progress-spinner>
<div *ngIf="!spinner">
    <h6 [attr.data-testid]="'change-set-details'">
        Found {{ changeSets?.length }} future change set(s) until
        <span *ngIf="data.featureScope === 'Legacy'; else elseBlock">{{ this.data.effectiveDate | date: 'medium' }}</span>
        <ng-template #elseBlock>
            <span>{{ atDefaultTimezone(this.data.effectiveDate)}}</span>
        </ng-template>
    </h6>
    <mat-accordion>
        <mat-expansion-panel
            *ngFor="let changeSet of changeSets"
            class="change-set"
            [ngClass]="{ 'change-set-open': changeSet == selectedChangeSet }"
            (closed)="closePanel(changeSet)"
            (opened)="openPanel(changeSet)"
        >
                <mat-expansion-panel-header class="change-set-panel-header">
                    <mat-panel-title [attr.data-testid]="'effective_date'">
                        Date
                    </mat-panel-title>
                    <mat-panel-description>
                        <div [attr.data-testid]="changeSet.label + '_label'" class="panel-description">
                            <span>{{ atDefaultTimezone(changeSet.effectiveDate) }}</span>
                            <mat-icon class="timezone-icon" [matTooltip]="changeSet.effectiveDate | date:'full'">access_time</mat-icon>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
            <emm-change-set
                [changeSet]="changeSet"
                [featureScope]="data.featureScope"
                [selectedConsumer]="data.consumer"
                [selectedLocation]="data.location"
                [selectedSubmenu]="data.submenu"
                [lastChange]="lastChange"
                [changeCount]="changeCount"
                (updatedName)="updateName($event, changeSet)"
            ></emm-change-set>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div class="buttons" mat-dialog-actions>
    <button
        [attr.data-testid]="'close_button'"
        class="button-color"
        mat-raised-button
        matTooltip="Close"
        (click)="onNoClick()"
    >Close</button>
</div>
